export const API_BASE_URL = import.meta.env.PROD ? "https://nickmorrison.me/api" : "http://localhost:3001/api";